import React from "react"
import { motion } from "framer-motion"
import { FaSpa, FaHotTub, FaLeaf, FaHands } from "react-icons/fa"

import SectionTitle from "../common/SectionTitle"

export default function SpaExperience() {
  const experiences = [
    {
      id: 1,
      icon: <FaSpa />,
      title: "Thérapie de Relaxation",
      description:
        "Des soins de relaxation profonde conçus pour réduire le stress et restaurer la paix intérieure.",
    },
    {
      id: 2,
      icon: <FaHotTub />,
      title: "Rituel de Hammam",
      description:
        "Rituels de purification traditionnels pour une détoxification complète du corps et un rajeunissement de la peau.",
    },
    {
      id: 3,
      icon: <FaLeaf />,
      title: "Bien-être Naturel",
      description:
        "Des soins spa biologiques et naturels qui respectent votre corps et votre peau.",
    },
    {
      id: 4,
      icon: <FaHands />,
      title: "Thérapie de Massage",
      description:
        "Techniques de massage professionnelles pour soulager les tensions et améliorer la circulation.",
    },
  ]

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          subtitle="Experience de Spa"
          title="Un Voyage Complet de Bien-être et de Détente"
          description="Chaque visite est conçue comme un véritable voyage sensoriel alliant confort, attention et soins de luxe."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {experiences.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="group bg-[#f9f6f1] rounded-[30px] p-8 shadow-lg hover:shadow-2xl transition-all duration-500 text-center"
            >
              {/* Icon */}
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-[#b8955d] text-white text-2xl shadow-md group-hover:scale-110 transition duration-300">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-[#111111] mt-6">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed mt-4 text-sm md:text-base">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}